<template>
  <a href="#main-content" class="skip-link" aria-label="Skip to main content">{{
    $t("skip")
  }}</a>
  <div class="flex flex-col">
    <SiteHeader />
    <div
      id="route-announcer"
      aria-live="polite"
      aria-atomic="true"
      class="sr-only"
    ></div>
    <div id="content">
      <router-view />
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from "./components/SiteHeader.vue";
import SiteFooter from "./components/SiteFooter.vue";

export default {
  name: "App",
  components: {
    SiteHeader,
    SiteFooter,
  },

  mounted() {
    this.addScrollListener();
    this.addSmoothScrollOnClick();
  },
  methods: {
    addScrollListener() {
      const headings = document.querySelectorAll("h2"); // Targeting h2 tags
      const navLinks = document.querySelectorAll("header ul a"); // Navigation links
      const headerHeight = document.querySelector("header").offsetHeight; // Get the height of the fixed header

      window.addEventListener("scroll", () => {
        let currentSection = "";

        headings.forEach((heading) => {
          const sectionTop = heading.offsetTop;
          const sectionHeight = heading.offsetHeight;

          // Adjust section top position by subtracting the header height and 100px margin
          if (
            window.pageYOffset >= sectionTop - headerHeight - 100 &&
            window.pageYOffset < sectionTop + sectionHeight - headerHeight - 100
          ) {
            currentSection = heading.getAttribute("id");
          }
        });

        navLinks.forEach((link) => {
          link.classList.remove("active"); // Remove active class from all links
          if (link.getAttribute("href").substring(1) === currentSection) {
            link.classList.add("active"); // Add active class to the current section's link
          }
        });
      });
    },

    addSmoothScrollOnClick() {
      const navLinks = document.querySelectorAll("header ul a");
      const headerHeight = document.querySelector("header").offsetHeight;

      navLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault(); // Prevent default anchor click behavior

          const targetId = link.getAttribute("href").substring(1); // Get the target section ID
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop - headerHeight - 100, // Scroll to the target section with an offset
              behavior: "smooth",
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
/* Optional: Define styles for the active navigation link */
header ul a.active {
  font-weight: bold;
  color: teal;
  /* or another color */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
